import { ApplicationElement, html } from '@crossiety/lit-components';

import translations from './translations.js';
import style from './style.lit.css';

import { StoreController } from '@crossiety/lit-components/lib/lit/store_controller.js';
import { computedChatsStore } from '@crossiety/lit-components/components/chat/lib/chats.store.js';

/**
 * TODO: Description
 *
 * @prop exampleProp - TODO: description
 *
 * @slot default - TODO: description
 * @slot namedSlot - TODO: description
 */

export default class ChatsIndex extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    muted: { type: Boolean },
    kind: { type: String },
    showFilters: { type: Boolean },
  };

  /** @internal */
  static translations = translations;

  storeController = new StoreController(this, computedChatsStore);

  constructor() {
    super();
    this.muted = false;
    this.showFilters = false;
    this.kind = '';
  }

  willUpdate(_prevChanges) {
    if (this.store.counters.muted === 0 && this.muted) {
      this.muted = false;
    }

    if (this.chatList) {
      this.chatList.muted = this.muted;
      this.chatList.kindFilter = this.kind;
    }
  }

  get store() {
    return this.storeController.value;
  }

  get chatList() {
    return this.querySelector('ef-chat-list');
  }

  get filtersVisible() {
    const { muted, group, direct } = this.store.counters;
    return this.showFilters && (muted || group || direct);
  }

  get searchInput() {
    return this.querySelector('input');
  }

  handleClickFilterLinks(e) {
    const target = e.target.closest('sl-tab');
    if (!target) return;

    const { name } = target.dataset;

    this.searchInput.value = '';
    this.chatList.titleFilter = '';

    if (name === 'muted') {
      this.muted = true;
      this.kind = '';
    } else {
      this.muted = false;
      this.kind = name;
    }
  }

  handleSearch(e) {
    this.searchValue = e.target.value;
    this.chatList.titleFilter = e.target.value;
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  renderBadge(count) {
    return html`<span class="suffix">(${count})</span>`;
  }

  renderButton({ title, name = '', count, active, show = true }) {
    if (!show) return null;

    return html`
      <sl-tab slot="nav" data-name=${name} ?active=${active} ?hidden=${!show}>
        <span>${title}</span>
        ${count ? this.renderBadge(count) : null}
      </sl-tab>
    `;
  }

  renderFilters() {
    const { unreadCounters, counters } = this.store;

    return html`
      <sl-tab-group @click=${this.handleClickFilterLinks}>
        ${this.renderButton({
          title: this.t('all'),
          count: unreadCounters.allWithoutMuted,
          active: !this.muted && !this.kind,
        })}
        ${this.renderButton({
          show: counters.direct + counters.multi,
          title: this.t('direct'),
          count: unreadCounters.direct + unreadCounters.multi,
          active: this.kind === 'direct,multi',
          name: 'direct,multi',
        })}
        ${this.renderButton({
          show: counters.group,
          title: this.t('group'),
          count: unreadCounters.group,
          active: this.kind === 'group',
          name: 'group',
        })}
        ${this.renderButton({
          show: counters.muted,
          title: this.t('muted'),
          count: unreadCounters.muted,
          active: this.muted,
          name: 'muted',
        })}
      </sl-tab-group>
    `;
  }

  render() {
    return html`
      ${this.filtersVisible ? this.renderFilters() : null}

      <header>
        <slot
          name="header"
          @input=${this.handleSearch}
          @change=${this.handleSearch}></slot>
      </header>

      <slot></slot>
    `;
  }
}

ChatsIndex.registerTagName('xs-chats-index');

customElements.get('xs-chats-index') ||
  customElements.define('xs-chats-index', ChatsIndex);
